export const calculatePercentile = (values, p) => {
  let n = values.length;
  if(n < 2) return null;

  values = values.sort((a,b) => +a > +b ? 1 : -1);

  let rank = (p * (n-1)) /100,
      first = Math.floor(rank),
      last = Math.ceil(rank),
      decimal = rank - first,
      first_value = values[first],
      last_value = values[last],
      percentile = first_value + decimal * (last_value - first_value);
   
  return percentile;
}


// WEBPACK FOOTER //
// ./src/libs/percentile.js